export default __webpack_public_path__ + "static/media/Customer-Blue-24x24.62bc0709.svg";